import { hasMinRole } from './adminAuthorization'

// UI는 이 capability만 사용한다. 실제 보안 경계는 Firestore Rules와 서버 requireAdmin()이다.
export function adminCapabilities(role) {
  const canWrite = hasMinRole(role, 'editor')
  return {
    isViewer: role === 'viewer',
    canWrite,
    canViewAdminRoles: hasMinRole(role, 'admin'),
    canManageAdmins: role === 'owner',
  }
}
